import { getLocalTime } from '@qualle-admin/qutil/dist/date';
import { getLineByPrefix } from '@qualle-admin/qutil/dist/ssl';
import containers from '../store/modules/containers';

export const defaultTurnData = {
  ref: null,
  container: null,
  amount: 0,
  description: null,
  lfd: getLocalTime().endOf('day').format(),
  chassis: null,
  chassisType: 'private',
  companyLocation: { address: null },
  line: null,
  location: { address: null },
  exportLocation: {
    address: null,
  },
  size: '40 HC',
  requestDetails: {
    type: 'same_carrier_request',
    secondaryCarrierScac: null,
    secondaryCarrierEmail: null,
  },
};

export const defaultContainerData = {
  ref: null,
  container: null,
  amount: 0,
  lfd: getLocalTime().endOf('day').format(),
  chassis: null,
  line: null,
  size: null,
  location: { address: null },
  chassisType: 'private',
};

export const setContainerData = ($event, requestItem) => {
  const { chassis, container, line, location, size, scac } =
    containers.state.containers.find(({ container }) => container === $event) ||
    requestItem;

  return Object.assign(requestItem, {
    chassis,
    location,
    scac,
    line: getLineByPrefix(container?.substring(0, 4)) || line,
    size: containers.state.sizes.some(({ id }) => id === size) ? size : null,
  });
};
export const defaultOverWeight = 44501;

export const minimumLegalWeight = 10000;

export const maximumOverWeight = 99999;
